<template>
  <div>
    <el-tabs v-model="currentAction" tab-position="top" :stretch="true">
      <el-tab-pane label="注册" name="register" tabindex="0" :lazy="true">
        <Register v-on:success="registered"></Register>
      </el-tab-pane>
      <el-tab-pane label="登录" name="login" tabindex="1" :lazy="true">
        <b-alert show v-if="registeredSuccessfully" variant="success">
          注册成功，激活邮件已经发送到您邮箱！
        </b-alert>
        <Login :redirect="redirect"></Login>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Login from "./Login.vue";
import Register from "./Register.vue";

export default {
  name: "loginAndRegister",
  props: {
    action: {
      type: String,
      required: false,
      default: "login"
    },
    redirect: {
      type: String,
      required: false,
      default: ""
    }
  },
  watch: {
    action: function() {
      this.currentAction = this.action;
    }
  },
  data: function() {
    return {
      currentAction: this.action,
      registeredSuccessfully: false
    };
  },
  components: {
    Login,
    Register
  },
  methods: {
    registered: function() {
      this.currentAction = "login";
      this.registeredSuccessfully = true;
    }
  }
};
</script>
